import { useState } from "react";
import { CalendarClock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";

const pad = (n) => String(n).padStart(2, "0");
const toLocalInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

export const ScheduleButton = ({ saved, busy, onSave }) => {
  const initial = saved?.status === "scheduled" ? new Date(saved.published_at) : new Date(Date.now() + 24 * 3600 * 1000);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(toLocalInput(initial));
  const valid = value && new Date(value) > new Date();

  const confirm = async () => {
    await onSave("scheduled", { scheduled_for: new Date(value).toISOString() });
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button disabled={busy} className="inline-flex items-center gap-2 font-ui text-sm px-4 py-2.5 border border-[#CFCFCB] bg-white hover:border-[var(--ink)] transition-colors disabled:opacity-50" data-testid="admin-schedule-button">
          <CalendarClock size={15} /> {saved?.status === "scheduled" ? "Reschedule" : "Schedule"}
        </button>
      </DialogTrigger>
      <DialogContent className="rounded-none">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Schedule this article</DialogTitle>
          <DialogDescription>It will go live automatically at this date and time (your local time).</DialogDescription>
        </DialogHeader>
        <input type="datetime-local" value={value} min={toLocalInput(new Date())} onChange={(e) => setValue(e.target.value)}
          className="w-full border border-[#CFCFCB] bg-white px-3 py-2.5 font-ui text-sm outline-none focus:border-[var(--ink)]" data-testid="admin-schedule-datetime-input" />
        {!valid && <p className="font-ui text-xs text-[var(--accent)]" data-testid="admin-schedule-error">Choose a time in the future.</p>}
        <div className="flex justify-end gap-2">
          <button onClick={() => setOpen(false)} className="font-ui text-sm px-4 py-2.5 border border-[#CFCFCB] hover:border-[var(--ink)]" data-testid="admin-schedule-cancel-button">Cancel</button>
          <button disabled={!valid || busy} onClick={confirm} className="font-ui text-sm px-4 py-2.5 bg-[var(--ink)] text-white hover:bg-[var(--accent)] disabled:opacity-50" data-testid="admin-schedule-confirm-button">Schedule</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
